import { ENV } from '../../constants/environments';

import { SalePriceBeforeDiscountProps } from '../../types/components/shared/SalePriceBeforeDiscount';

const SalePriceBeforeDiscount: React.FC<SalePriceBeforeDiscountProps> = ({
  priceBeforeDiscount,
  className
}) => {
  if (ENV.displaySaleBanner !== 'true' || !priceBeforeDiscount) return;

  return (
    <span
      cy-test-id="sale-price-before-discount"
      className={`text-[18px] leading-[18px] text-red-800 line-through ${className ?? ''}`}
    >
      {`$${priceBeforeDiscount}`}
    </span>
  );
};

export default SalePriceBeforeDiscount;
